export var phoneReg = /^1[0-9]{10}$/;
/** 18 位大陆居民身份证号码格式（末位可为 X），不含校验位算法 */
export var idCardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
export var bankCardReg = /^[0-9]{16,20}$/;
export var emailReg = /^[\w.-]+@[a-z0-9.-]+\.[a-z]{2,10}$/i;
export var qqReg = /^[0-9]{5,10}$/;
export var moneyReg = /^[0-9]+(\.[0-9]{1,2})?$/;
export var urlReg = /(https?:\/\/[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]+)/gi;
